<template>
  <div>
    <template>
      <v-card class="mx-auto" justifiy="center" align="center">
        <v-app-bar class="transparent" light flat>
          <v-toolbar-title> 
              <v-btn icon @click.stop="$router.go(-1)">
            <v-icon>mdi-arrow-left-circle-outline</v-icon>
          </v-btn> Membres du groupe {{ $route.params.groupe.nom_groupe }}</v-toolbar-title
          ><v-spacer></v-spacer>
        </v-app-bar>

        <v-card flat>
          <v-card-text>
            <div class="flex-table">
              <div>Nom</div>
              <div>sexe</div>
              <div>annee_naissance</div>
              <div>Age</div>
              <div>Action</div>
            </div>
            <div
              class="flex-table"
              v-for="(item, index) in MembresDuGroupe"
              :key="index"
            >
              <div>{{ item.nom }}</div>
              <div>{{ getSexe(item.sexe) }}</div>
              <div>{{ item.annee_naissance }}</div>
              <div>
                {{ calculate_age(new Date(item.annee_naissance, 1, 1)) }} ans
              </div>

              <div>
                <v-icon v-if="item.active == '0'" small class="mr-2"
                  >mdi-cog</v-icon
                >
              </div>
            </div>
          </v-card-text>
        </v-card>

        <v-card-actions>
          <Navigation :elements="AdminNavigation" />
        </v-card-actions>
      </v-card>
    </template>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

export default {
  created() {
    this.GetMembresDuGroupe(this.$route.params.groupe.id);
  },
  components: {
    Navigation: require("@/components/Navigation.vue").default,
  },
  methods: {
    getSexe(sexe) {
      if (sexe == "1") {
        return "Masculin";
      } else {
        return "Féminin";
      }
    },
    calculate_age(dob) {
      var diff_ms = Date.now() - dob.getTime();
      var age_dt = new Date(diff_ms);

      return Math.abs(age_dt.getUTCFullYear() - 1970);
    },
    ...mapActions({
      GetMembresDuGroupe: "Membres/GetMembresDuGroupe",
    }),
  },
  computed: {
    ...mapState({
      MembresDuGroupe: (state) => state.Membres.MembresDuGroupe,
      AdminNavigation: (state) => state.Navigation.AdminNavigation,
    }),
  },
};
</script>

<style scoped>
.flex-table {
  display: grid;
  grid-template-columns: repeat(auto-fill, 20%);
  padding: 10px;
  border-bottom: 1px #ccc solid;
}
</style>
